<template>
  <div class="container-wrapper full-height no-progress-bar">
    <div class="text-center mx-auto copy-container">
      <h2 :class="{ 'mb-4 mb-sm-5': !isRegionalCreditScoreSet && isNeighbourhoodEnabled }" class="mb-4 pt-4 px-large">
        {{ title }}
      </h2>
      <p v-if="isRegionalCreditScoreSet && !isNeighbourhoodEnabled" class="p-small rcs-text mx-sm-5 px-2">
        {{ $t('message.eCommerceV2.credit.results.regionalText') }}
      </p>
    </div>
    <CreditResultDetails
      class="mt-5"
      :creditVisionScore="creditVisionScore"
      :tradeLines="this.$store.state.credit.tradeLines"
      :creditRange="creditRange"
    >
    </CreditResultDetails>
    <div class="push-down-desktop">
      <mobialis-button
        type="button"
        class="mt-5 mb-3"
        @click="clickBtn"
        data-cy="continue"
        v-av-analytics-cta-interaction="{ elementText: buttonText, eventActionResult: 'open' }"
        >{{ buttonText }}</mobialis-button
      >
      <p v-if="isEquifax" class="mt-0 font-size-10 color-primary-grey">{{ $t('message.credit.disclaimer.equifax') }}</p>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import CreditResultDetails from '@/components/credit-results/CreditResultDetails.vue';

export default {
  name: 'CreditResults',
  components: {
    CreditResultDetails,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState('route', ['from']),
    ...mapState({
      defaultCreditDataSourceCA: state => state.business.info.creditSettings.defaultCreditDataSourceCA,
    }),
    ...mapGetters({
      creditScoreGrade: 'credit/creditScoreGrade',
      regionalCreditScoreGrade: 'credit/regionalCreditScoreGrade',
      creditVisionScore: 'credit/creditVisionScore',
    }),
    isEquifax() {
      return this.defaultCreditDataSourceCA === this.enums.CreditDataSourceCA.EQUIFAX;
    },
    isNeighbourhoodEnabled() {
      return this.defaultCreditDataSourceCA === this.enums.CreditDataSourceCA.NEIGHBOURHOOD_CREDIT;
    },
    creditRange() {
      return this.creditScoreGrade || this.regionalCreditScoreGrade;
    },
    isRegionalCreditScoreSet() {
      return !!this.regionalCreditScoreGrade;
    },
    title() {
      if (this.isRegionalCreditScoreSet) {
        if (!this.isNeighbourhoodEnabled) {
          return this.$t('message.eCommerceV2.credit.results.regionalTitle2');
        }
        return this.$t('message.eCommerceV2.credit.results.regionalTitle');
      }
      return this.$t('message.eCommerceV2.credit.results.resultsTitle');
    },
    buttonText() {
      if (this.from.path.includes('payment-calculator') || this.from.path.includes('payment-summary')) {
        return this.$t('message.eCommerceV2.tradeInFlow.results.backToDeal');
      }
      return this.$t('message.eCommerceV2.credit.results.buttonText');
    },
  },
  methods: {
    async clickBtn() {
      this.$router.push({ path: this.getNextRoutePath() });
    },
  },
};
</script>

<style scoped lang="scss">
.copy-container {
  max-width: 450px;
}
</style>
